/* Riotone · Página de producto */
if (!customElements.get('rt-product')) {
  customElements.define('rt-product', class RtProduct extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form[data-type="add-to-cart-form"]');
      this.idInput = this.querySelector('.rt-variant-id');
      this.addBtn = this.querySelector('.rt-add');
      this.errorEl = this.querySelector('.rt-error');
      try {
        this.variants = JSON.parse(this.querySelector('.rt-variants').textContent);
      } catch (e) {
        this.variants = [];
      }

      this.initGallery();
      this.initOptions();
      this.initSizeGuide();
      this.initCart();
    }

    /* ---------- Galería ---------- */
    initGallery() {
      this.slides = Array.from(this.querySelectorAll('.rt-slide[data-media-id]'));
      this.thumbs = Array.from(this.querySelectorAll('.rt-thumb'));
      this.thumbs.forEach((t) => t.addEventListener('click', () => this.showMedia(t.dataset.mediaId)));
      this.querySelectorAll('.rt-arrow').forEach((a) => {
        a.addEventListener('click', () => {
          const i = this.slides.findIndex((s) => !s.hidden);
          const n = this.slides.length;
          const next = (i + Number(a.dataset.dir) + n) % n;
          this.showMedia(this.slides[next].dataset.mediaId);
        });
      });
    }

    showMedia(id) {
      if (!id) return;
      this.slides.forEach((s) => {
        const on = s.dataset.mediaId === String(id);
        s.hidden = !on;
        if (!on) s.querySelectorAll('video').forEach((v) => v.pause());
      });
      this.thumbs.forEach((t) => {
        const on = t.dataset.mediaId === String(id);
        t.classList.toggle('is-active', on);
        if (on) t.setAttribute('aria-current', 'true');
        else t.removeAttribute('aria-current');
      });
    }

    /* ---------- Tallas / variantes ---------- */
    initOptions() {
      this.groups = Array.from(this.querySelectorAll('.rt-option'));
      if (!this.groups.length) return;
      this.groups.forEach((g) => g.addEventListener('change', () => this.onOptionChange()));
      this.markSoldOut();
    }

    selectedOptions() {
      return this.groups.map((g) => {
        const c = g.querySelector('input:checked');
        return c ? c.value : null;
      });
    }

    onOptionChange() {
      const sel = this.selectedOptions();
      const v = this.variants.find((x) => x.options.every((o, i) => o === sel[i]));
      this.markSoldOut();
      this.updateVariant(v);
    }

    markSoldOut() {
      const sel = this.selectedOptions();
      this.groups.forEach((g, gi) => {
        g.querySelectorAll('.rt-pill').forEach((pill) => {
          const val = pill.querySelector('input').value;
          const avail = this.variants.some((x) =>
            x.available && x.options[gi] === val &&
            x.options.every((o, i) => i === gi || sel[i] === null || o === sel[i])
          );
          pill.classList.toggle('is-soldout', !avail);
        });
      });
    }

    updateVariant(v) {
      const label = this.addBtn ? this.addBtn.querySelector('.rt-add-text') : null;
      if (!v) {
        if (this.addBtn) { this.addBtn.disabled = true; label.textContent = this.addBtn.dataset.labelUnavailable; }
        this.toggleDynamic(false);
        return;
      }
      if (this.idInput) {
        this.idInput.value = v.id;
        this.idInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      const now = this.querySelector('.rt-price-now');
      const was = this.querySelector('.rt-price-was');
      if (now) now.textContent = v.price;
      if (was) { was.hidden = !v.compare; was.textContent = v.compare || ''; }

      if (this.addBtn) {
        this.addBtn.disabled = !v.available;
        label.textContent = v.available ? this.addBtn.dataset.labelAdd : this.addBtn.dataset.labelSoldout;
      }
      this.toggleDynamic(v.available);

      const stock = this.querySelector('.rt-stock');
      if (stock) {
        const th = Number(stock.dataset.threshold || 0);
        const show = v.tracked && v.qty > 0 && v.qty <= th;
        stock.hidden = !show;
        if (show) stock.textContent = v.qty === 1 ? 'Última pieza en esta talla' : 'Últimas ' + v.qty + ' piezas en esta talla';
      }

      if (v.media) this.showMedia(v.media);

      const url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
      if (this.errorEl) this.errorEl.hidden = true;
    }

    toggleDynamic(on) {
      const d = this.querySelector('.rt-dynamic');
      if (d) d.style.display = on ? '' : 'none';
    }

    /* ---------- Guía de tallas (popup) ---------- */
    initSizeGuide() {
      this.querySelectorAll('[data-rt-open]').forEach((btn) => {
        btn.addEventListener('click', () => {
          const dlg = document.getElementById(btn.dataset.rtOpen);
          if (!dlg) return;
          this.lastFocus = btn;
          if (typeof dlg.showModal === 'function') dlg.showModal();
          else dlg.setAttribute('open', '');
          document.documentElement.classList.add('rt-lock');
        });
      });
      this.querySelectorAll('dialog.rt-modal').forEach((dlg) => {
        const close = () => { if (dlg.open) dlg.close(); else dlg.removeAttribute('open'); };
        dlg.querySelectorAll('[data-rt-close]').forEach((b) => b.addEventListener('click', close));
        dlg.addEventListener('click', (e) => { if (e.target === dlg) close(); });
        dlg.addEventListener('close', () => {
          document.documentElement.classList.remove('rt-lock');
          if (this.lastFocus) this.lastFocus.focus();
        });
      });
    }

    /* ---------- Agregar al carrito (abre el carrito lateral de Rise) ---------- */
    initCart() {
      if (!this.form) return;
      this.form.addEventListener('submit', (e) => {
        if (e.submitter && e.submitter.closest('.rt-dynamic')) return;
        e.preventDefault();
        this.addToCart();
      });
    }

    async addToCart() {
      if (!this.addBtn || this.addBtn.disabled) return;
      this.addBtn.classList.add('is-loading');
      this.addBtn.setAttribute('aria-disabled', 'true');
      if (this.errorEl) this.errorEl.hidden = true;

      const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      const fd = new FormData(this.form);
      let sections = [];
      try {
        if (cart && typeof cart.getSectionsToRender === 'function') {
          sections = cart.getSectionsToRender().map((s) => s.id);
        }
      } catch (err) { sections = []; }
      if (sections.length) {
        fd.append('sections', sections.join(','));
        fd.append('sections_url', window.location.pathname);
        if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
      }

      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      try {
        const res = await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
          body: fd
        });
        const data = await res.json();
        if (data.status) {
          this.showError(data.description || data.message || 'No se pudo agregar al carrito.');
          return;
        }
        if (typeof window.publish === 'function' && typeof window.PUB_SUB_EVENTS !== 'undefined') {
          window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'riotone-product', productVariantId: fd.get('id'), cartData: data });
        }
        if (cart && sections.length && typeof cart.renderContents === 'function') {
          if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
          cart.renderContents(data);
        } else {
          window.location.href = root + 'cart';
        }
      } catch (err) {
        this.form.submit();
      } finally {
        this.addBtn.classList.remove('is-loading');
        this.addBtn.removeAttribute('aria-disabled');
      }
    }

    showError(msg) {
      if (!this.errorEl) return;
      this.errorEl.textContent = msg;
      this.errorEl.hidden = false;
    }
  });
}
